import TemplateView from '../../../../TemplateView'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import messageResource from '../../../../messageResource'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import {ValidationErrors} from '../../constants'

export default class EffectiveDateCell extends TemplateView {
    constructor({
        dateFromLabel,
        readOnly,
        scrollTo,
        onChangeCb = () => {},
        rollbackChanges = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()

        this.params = {
            dateFromLabel,
            scrollTo,
            readOnly,
        }

        this.callbacks = {
            onChangeCb,
            rollbackChanges,
            subscribeSelectorOnScroll,
        }

        this.state = {
            invertedDays: {},
            weekStartDay: 0,
            defaultWorkSchedule: [],
            date: null,
            effective: false,
            needShowWarning: false,
            error: null,
        }

        this.onStateChanged(() => this._update())

        this.onStatePropertyChanged('error', error => this._updateError(error))
        this.onStatePropertyBecameTrue('needShowWarning', () => this._showDuplicateWarning())
    }

    templateHtml() {
        return '<div class="effectiveDateCellContent">' +
               '    <div class="dateSelectorPlaceholder">' +
               '        <div class="dateFromLabel"><%=dateFromLabel%></div>' +
               '        <div class="dateSelector atNextMount"/>' +
               '        <div class="dateLabel"></div>' +
               '    </div>' +
               '    <div class="currentLabel"><%=currentLabel%></div>' +
               '</div>'
    }

    templateModel() {
        return {
            dateFromLabel: this.params.dateFromLabel
        }
    }

    messageKeys() {
        return {
            currentLabel: 'user.add_edit.js.wd_editor.working_schedule_current'
        }
    }

    afterRender() {
        this.$dateSelector = this.find('.dateSelector')
        this.$currentLabel = this.find('.currentLabel')
        this.$dateLabel = this.find('.dateLabel')

        const date = this.state.date ? this.state.date.parseJSONDate() : null

        this.dateSelector = window.ClassicBridge.integrateCalendar(this.$dateSelector[0], {
            onSelect: (date) => {
                this.callbacks.onChangeCb(Date.parseJSONDate(date).toJSON());
                this.dateSelector.setProps({ selectedDay: date }); 
            },
            selectedDay: date,
            placeholder: !date && messageResource.getMessage("common.date_selector.select_date"),
            type: 'day',
            compactDate: true
        })
    }

    hideSelector() {
    }

    _update() {
        this.$currentLabel.toggle(this.state.effective)
        this.$dateLabel.toggle(this.params.readOnly)

        const date = this.state.date ? this.state.date.parseJSONDate() : null
        const format = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M")

        this.dateSelector.setProps({
            selectedDay: date,
            placeholder: !date && messageResource.getMessage("common.date_selector.select_date"),
        }); 

        if (this.params.readOnly) {
            if (!!date)
                this.$dateLabel.text(date.format(format))
            return
        }
    }

    _updateError(error) {
        this.getEl().toggleClass('invalid', error !== null)

        if (error) {
            this.dateSelector.setProps({ triggerClassName: "error" });
        } else {
            this.dateSelector.setProps({ triggerClassName: "" });
        }

        if (error === ValidationErrors.DUPLICATED_EFFECTIVE_DATE)
            this.$dateSelector.attr('title', messageResource.getMessage('rates.errors.duplicate_date'))
    }

    _showDuplicateWarning() {
        const msg =
            messageResource.getMessage('rates.editor.work_schedule.duplicate_date') + '\n' +
            messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo(this.$dateSelector)

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.LEFT
        }).showAt(this.$dateSelector, () => {
            this.callbacks.rollbackChanges()
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/EffectiveDateCell.js